import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SessionInterceptor } from './auth/session.interceptor';
import { ConfirmDialogComponent } from './common/confirm-dialog/confirm-dialog.component';
import { MaterialModule } from '../common/material/material.module';
import { TimezoneInterceptor } from './timezone.interceptor';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TimezoneInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
    declarations: [
        ConfirmDialogComponent,
    ],
})
export class ServiceModule {
}
